import {
	Box,
	IconButton,
	Typography
} from "@mui/material";
import { TopBarStyle } from "./TopBar.styled";

import Toolbar from '@mui/material/Toolbar';
import clsx from "clsx";
import { ReactComponent as HelpIcon } from '@common/images/HelpIcon.svg';
import { ReactComponent as NoticeIcon } from '@common/images/NoticeIcon.svg';
import { ReactComponent as PageLogo } from '@common/images/PageLogo.svg';
import { ReactComponent as ProfileIcon } from '@common/images/ProfileIcon.svg';

import { styled } from '@mui/system';
import { observer } from "mobx-react";
import useEmotionStyles from "../../../styles/shared/useEmotionStyles";

const TopBar = styled(Toolbar)({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
});

type Props = {}

function TableHomeTopBar(props: Props) {
	const classes = useEmotionStyles(TopBarStyle);

	return (
		<div className={classes.root}>
			<TopBar className={classes.topBar}>
				<Box display='flex' alignItems='center' justifyContent='center'>
					<Box display='flex' alignItems='center' justifyContent='center'>
						<Box
							color="inherit"
							aria-label="toggle drawer"
							className={clsx(classes.iconBtnReset, classes.iconToggle)}>
							<PageLogo />
						</Box>
						<Typography className={classes.topBarTitle}>서논술형 평가 도구</Typography>
					</Box>
				</Box>
				<Box>
					<IconButton className={clsx(classes.iconBtnReset, classes.iconButton)} disableRipple>
						<NoticeIcon />
					</IconButton>
					<IconButton className={clsx(classes.iconBtnReset, classes.iconButton)} disableRipple>
						<HelpIcon />
					</IconButton>
					<IconButton className={clsx(classes.iconBtnReset, classes.iconButton)} disableRipple>
						<ProfileIcon />
					</IconButton>
				</Box>
			</TopBar>
		</div>
	);
}

export default observer<typeof TableHomeTopBar>(TableHomeTopBar);
